import React, { useEffect, useRef } from "react";
import { FaCheck } from "react-icons/fa";
import { FaChevronDown } from "react-icons/fa";
import Link from "next/link";
import SeoHead from '../component/SeoHead';
import metaData from '../data/Meta.json';
import { jsonLdByPath } from '../data/SchemaTag.js';
export async function getServerSideProps(context) {
  const path = context.resolvedUrl.toLowerCase();

  const matchedMeta = metaData.find(item => item.url?.toLowerCase().endsWith(path)) || {};

  const pageJson = jsonLdByPath.find(item => item.url?.toLowerCase().endsWith(path));

  const title = matchedMeta?.title || 'Millance';
  const description = matchedMeta?.description || 'Trade smarter with Millance.';
  const url = matchedMeta?.url || `https://millance.com${path}`;
  const jsonLd = pageJson || null;

  return {
    props: { meta: { title, description, url }, jsonLd, }
  };
}
const Currency = ({ meta, jsonLd }) => {
  const currencychart = useRef();
  const currencygraph1 = useRef();
  const currencygraph2 = useRef();
  const currencygraph3 = useRef();
  const currencygraph4 = useRef();

  useEffect(() => {
    const script = document.createElement("script");

    script.src =
      "https://s3.tradingview.com/external-embedding/embed-widget-symbol-overview.js";
    script.async = false;
    script.innerHTML = JSON.stringify({
      symbols: [[" EUR/USD", "OANDA:EURUSD|12M"]],
      chartOnly: false,
      width: "100%",

      height: "400",
      locale: "in",
      colorTheme: "light",
      autosize: false,
      showVolume: false,
      hideDateRanges: false,
      hideMarketStatus: false,
      hideSymbolLogo: false,
      scalePosition: "right",
      scaleMode: "Normal",
      fontFamily:
        "-apple-system, BlinkMacSystemFont, Trebuchet MS, Roboto, Ubuntu, sans-serif",
      fontSize: "10",
      noTimeScale: false,
      valuesTracking: "1",
      changeMode: "price-and-percent",
      chartType: "line",
      color: "rgba(76, 175, 80, 1)",
    });

    currencygraph2.current.appendChild(script);
  }, []);

  useEffect(() => {
    const script = document.createElement("script");

    script.src =
      "https://s3.tradingview.com/external-embedding/embed-widget-symbol-overview.js";
    script.async = false;
    script.innerHTML = JSON.stringify({
      symbols: [["GBP/USD", "OANDA:GBPUSD|12M"]],
      chartOnly: false,
      width: "100%",
      height: "400",
      locale: "in",
      colorTheme: "light",
      autosize: false,
      showVolume: false,
      hideDateRanges: false,
      hideMarketStatus: false,
      hideSymbolLogo: false,
      scalePosition: "right",
      scaleMode: "Normal",
      fontFamily:
        "-apple-system, BlinkMacSystemFont, Trebuchet MS, Roboto, Ubuntu, sans-serif",
      fontSize: "10",
      noTimeScale: false,
      valuesTracking: "1",
      changeMode: "price-and-percent",
      chartType: "line",
      color: "rgba(76, 175, 80, 1)",
    });

    currencygraph1.current.appendChild(script);
  }, []);

  useEffect(() => {
    const script = document.createElement("script");

    script.src =
      "https://s3.tradingview.com/external-embedding/embed-widget-symbol-overview.js";
    script.async = false;
    script.innerHTML = JSON.stringify({
      symbols: [["USD/JPY", "OANDA:USDJPY|12M"]],
      chartOnly: false,
      width: "100%",
      height: "400",
      locale: "in",
      colorTheme: "light",
      autosize: false,
      showVolume: false,
      hideDateRanges: false,
      hideMarketStatus: false,
      hideSymbolLogo: false,
      scalePosition: "right",
      scaleMode: "Normal",
      fontFamily:
        "-apple-system, BlinkMacSystemFont, Trebuchet MS, Roboto, Ubuntu, sans-serif",
      fontSize: "10",
      noTimeScale: false,
      valuesTracking: "1",
      changeMode: "price-and-percent",
      chartType: "line",
      color: "rgba(76, 175, 80, 1)",
    });

    currencygraph3.current.appendChild(script);
  }, []);

  useEffect(() => {
    const script = document.createElement("script");

    script.src =
      "https://s3.tradingview.com/external-embedding/embed-widget-symbol-overview.js";
    script.async = false;
    script.innerHTML = JSON.stringify({
      symbols: [["USD/CHF", "OANDA:USDCHF|12M"]],
      chartOnly: false,
      width: "100%",
      height: "400",
      locale: "in",
      colorTheme: "light",
      autosize: false,
      showVolume: false,
      hideDateRanges: false,
      hideMarketStatus: false,
      hideSymbolLogo: false,
      scalePosition: "right",
      scaleMode: "Normal",
      fontFamily:
        "-apple-system, BlinkMacSystemFont, Trebuchet MS, Roboto, Ubuntu, sans-serif",
      fontSize: "10",
      noTimeScale: false,
      valuesTracking: "1",
      changeMode: "price-and-percent",
      chartType: "line",
      color: "rgba(76, 175, 80, 1)",
    });

    currencygraph4.current.appendChild(script);
  }, []);

  useEffect(() => {
    const script = document.createElement("script");
    script.src =
      "https://s3.tradingview.com/external-embedding/embed-widget-market-overview.js";
    script.async = false;
    script.innerHTML = JSON.stringify({
      colorTheme: "light",
      dateRange: "12M",
      showChart: true,
      locale: "in",
      largeChartUrl: "",
      isTransparent: false,
      showSymbolLogo: true,
      showFloatingTooltip: false,
      width: "100%",
      height: "660",
      plotLineColorGrowing: "rgba(41, 98, 255, 1)",
      plotLineColorFalling: "rgba(41, 98, 255, 1)",
      gridLineColor: "rgba(240, 243, 250, 0)",
      scaleFontColor: "rgba(106, 109, 120, 1)",
      belowLineFillColorGrowing: "rgba(41, 98, 255, 0.12)",
      belowLineFillColorFalling: "rgba(41, 98, 255, 0.12)",
      belowLineFillColorGrowingBottom: "rgba(41, 98, 255, 0)",
      belowLineFillColorFallingBottom: "rgba(41, 98, 255, 0)",
      symbolActiveColor: "rgba(41, 98, 255, 0.12)",

      tabs: [
        {
          title: "Forex",
          symbols: [
            {
              s: "FX:EURUSD",
              d: "EUR/USD",
            },
            {
              s: "FX:GBPUSD",
              d: "GBP/USD",
            },
            {
              s: "FX:USDJPY",
              d: "USD/JPY",
            },
            {
              s: "FX:USDCHF",
              d: "USD/CHF",
            },
            {
              s: "FX:AUDUSD",
              d: "AUD/USD",
            },
            {
              s: "FX:USDCAD",
              d: "USD/CAD",
            },
          ],
          originalTitle: "Forex",
        },
      ],
    });

    currencychart.current.appendChild(script);
  }, []);

  useEffect(() => {
    setTimeout(() => {
      window.scroll({
        top: 0,

        behavior: "smooth",
      });
    }, 100);
  }, []);

  return (
    <>
      <SeoHead title={meta.title} description={meta.description} jsonLd={jsonLd} url={meta.url} />
      <div className="asset-currency-page">
        <section className="mt5trade">
          <div className="mt5cont">
            <div className="container">
              <div className="row align-items-center">
                <div className="col-md-12 col-lg-6 ">
                  <h1 className=" mb-2">Currency Trading</h1>
                  <p className=" mb-3">
                    At Millance LTD, we empower you with the flexibility to copy trade currencies on your terms, providing an affordable and efficient platform for engaging in the world’s largest and most liquid market.
                  </p>
                </div>
                <div className="col-md-12 col-lg-6">
                  <img
                    src={"/images/main/Currency.gif"}
                    alt="logo"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="assets-content-page">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-2 col-md-12 col-12 col-sm-12">
                <div className="product1 markettab pb-5 mb-5 mt-4">
                  <div className="nav-tabs-menu">
                    <ul
                      className="nav nav-tabs d-flex"
                      id="ProductTab"
                      role="tablist"
                    >
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link active"
                          id="Currecny-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#Currecny"
                          type="button"
                          role="tab"
                          aria-controls="Currecny"
                          aria-selected="true"
                        >
                          Currencies
                        </button>
                      </li>
                    </ul>
                  </div>
                  <div className="tab-content" id="ProductTabContent">
                    <div
                      className="tab-pane fade active show"
                      id="Currecny"
                      role="tabpanel"
                      aria-labelledby="Currecny-tab"
                    >
                      <div className="curre">
                        <div ref={currencychart}></div>

                        <Link
                          href="https://crm.millance.com/register"
                          className="optrade btn mb-3"
                        >
                          Open trading account
                        </Link>
                        <Link href="/metatrader-5" className="downtrade btn">
                          Download trading platform
                        </Link>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="Crypto"
                      role="tabpanel"
                      aria-labelledby="Crypto-tab"
                    >
                      <div className="curre">
                        <img
                          src={"/images/main/marketchart.png"}
                          alt="logo"
                          className="img-fluid"
                        />
                        <div className="table-responsive">
                          <table className="table">
                            <tbody>
                              <tr>
                                <td className="coinname">
                                  <a href="#">EURUSD</a>
                                </td>
                                <td className="val1">
                                  <a href="#">1.066</a>
                                </td>
                                <td className="val2">
                                  <a href="#">0.222</a>
                                </td>
                                <td className="val4">
                                  <a href="#">
                                    -0.12%{" "}
                                    <i className="mx-2 text-danger">
                                      <FaChevronDown />
                                    </i>
                                  </a>
                                </td>
                              </tr>
                              <tr>
                                <td className="coinname">
                                  <a href="#">GBPUSD</a>
                                </td>
                                <td className="val1">
                                  <a href="#">1.2062</a>
                                </td>
                                <td className="val2">
                                  <a href="#">-0.3967</a>
                                </td>
                                <td className="val4">
                                  <a href="">
                                    -0.22%{" "}
                                    <i className="mx-2 text-danger">
                                      <FaChevronDown />
                                    </i>
                                  </a>
                                </td>
                              </tr>
                              <tr>
                                <td className="coinname">
                                  <a href="#">USDJPY</a>
                                </td>
                                <td className="val1">
                                  <a href="#">130.95</a>
                                </td>
                                <td className="val2">
                                  <a href="#">-0.36</a>
                                </td>
                                <td className="val4">
                                  <a href="#">
                                    -00.5%
                                    <i className="mx-2 text-danger">
                                      <FaChevronDown />
                                    </i>
                                  </a>
                                </td>
                              </tr>
                              <tr>
                                <td className="coinname">
                                  <a href="#">USDCHF</a>
                                </td>
                                <td className="val1">
                                  <a href="#">0.9237</a>
                                </td>
                                <td className="val2">
                                  <a href="#">-0.765</a>
                                </td>
                                <td className="val5">
                                  <a href="#">
                                    -00.9%
                                    <i className="mx-2 text-success">
                                      <FaChevronDown />
                                    </i>
                                  </a>
                                </td>
                              </tr>
                              <tr>
                                <td className="coinname">
                                  <a href="#">USDCAD</a>
                                </td>
                                <td className="val1">
                                  <a href="#">1.856</a>
                                </td>
                                <td className="val3">
                                  <a href="#">-0.011</a>
                                </td>
                                <td className="val4">
                                  <a href="#">
                                    -00.7%
                                    <i className="mx-2 text-danger">
                                      <FaChevronDown />
                                    </i>
                                  </a>
                                </td>
                              </tr>
                              <tr>
                                <td className="coinname">
                                  <a href="#">AUDUSD</a>
                                </td>
                                <td className="val1">
                                  <a href="#">1.258</a>
                                </td>
                                <td className="val3">
                                  <a href="#">-0.0013</a>
                                </td>
                                <td className="val5">
                                  <a href="#">
                                    -00.8%
                                    <i className="mx-2 text-success">
                                      <FaChevronDown />
                                    </i>
                                  </a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div className="marketbtn d-block flex-column align-items-center">
                          <div
                            /* to="https://crm.millance.com/register" */
                            className="optrade btn mb-3"
                          >
                            Open trading account
                          </div>
                          <Link href="/metatrader-5" className="downtrade btn">
                            Download trading platform
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="Shares"
                      role="tabpanel"
                      aria-labelledby="Shares-tab"
                    >
                      <div className="curre">
                        <img
                          src={"/images/main/marketchart.png"}
                          alt="logo"
                          className="img-fluid"
                        />
                        <div className="table-responsive">
                          <table className="table">
                            <tbody>
                              <tr>
                                <td className="coinname">
                                  <a href="#">EURUSD</a>
                                </td>
                                <td className="val1">
                                  <a href="#">1.066</a>
                                </td>
                                <td className="val2">
                                  <a href="#">0.222</a>
                                </td>
                                <td className="val4">
                                  <a href="#">
                                    -0.12%{" "}
                                    <i className="mx-2 text-danger">
                                      <FaChevronDown />
                                    </i>
                                  </a>
                                </td>
                              </tr>
                              <tr>
                                <td className="coinname">
                                  <a href="#">GBPUSD</a>
                                </td>
                                <td className="val1">
                                  <a href="#">1.2062</a>
                                </td>
                                <td className="val2">
                                  <a href="#">-0.3967</a>
                                </td>
                                <td className="val4">
                                  <a href="">
                                    -0.22%{" "}
                                    <i className="mx-2 text-danger">
                                      <FaChevronDown />
                                    </i>
                                  </a>
                                </td>
                              </tr>
                              <tr>
                                <td className="coinname">
                                  <a href="#">USDJPY</a>
                                </td>
                                <td className="val1">
                                  <a href="#">130.95</a>
                                </td>
                                <td className="val2">
                                  <a href="#">-0.36</a>
                                </td>
                                <td className="val4">
                                  <a href="#">
                                    -00.5%
                                    <i className="mx-2 text-danger">
                                      <FaChevronDown />
                                    </i>
                                  </a>
                                </td>
                              </tr>
                              <tr>
                                <td className="coinname">
                                  <a href="#">USDCHF</a>
                                </td>
                                <td className="val1">
                                  <a href="#">0.9237</a>
                                </td>
                                <td className="val2">
                                  <a href="#">-0.765</a>
                                </td>
                                <td className="val5">
                                  <a href="#">
                                    -00.9%
                                    <i className="mx-2 text-success">
                                      <FaChevronDown />
                                    </i>
                                  </a>
                                </td>
                              </tr>
                              <tr>
                                <td className="coinname">
                                  <a href="#">USDCAD</a>
                                </td>
                                <td className="val1">
                                  <a href="#">1.856</a>
                                </td>
                                <td className="val3">
                                  <a href="#">-0.011</a>
                                </td>
                                <td className="val4">
                                  <a href="#">
                                    -00.7%
                                    <i className="mx-2 text-danger">
                                      <FaChevronDown />
                                    </i>
                                  </a>
                                </td>
                              </tr>
                              <tr>
                                <td className="coinname">
                                  <a href="#">AUDUSD</a>
                                </td>
                                <td className="val1">
                                  <a href="#">1.258</a>
                                </td>
                                <td className="val3">
                                  <a href="#">-0.0013</a>
                                </td>
                                <td className="val5">
                                  <a href="#">
                                    -00.8%
                                    <i className="mx-2 text-success">
                                      <FaChevronDown />
                                    </i>
                                  </a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div className="marketbtn d-block flex-column align-items-center">
                          <a className="optrade btn mb-3" href="#">
                            Open trading account
                          </a>
                          <a className="downtrade btn" href="#">
                            Download trading platform
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-8 col-md-12 col-12 col-sm-12">
                <div className="asset-box1 mt-4 ">
                  <div className="tab-content" id="v-pills-tabContent">
                    <div
                      className="tab-pane fade show active"
                      id="v-pills-link1"
                      role="tabpanel"
                      aria-labelledby="v-pills-link1-tab"
                    >
                      <div className="row">
                        <div className="col-lg-6 col-md-12 col-12 col-sm-12">
                          <div className="currency-assets px-3">
                            <h4>Currency</h4>
                          </div>
                          <div className="currency-asset1 mt-3">
                            <p>
                              <i className="altick">
                                <FaCheck />
                              </i>
                              Copy trade Major, Minor, and Exotic Currency Pairs!
                              With a daily trading volume exceeding $5 trillion, the forex market offers immense opportunities. Millance LTD gives you access to a diverse range of currency pairs, enabling you to capitalize on global market movements.
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12 col-12 col-sm-12 d-flex align-items-center">
                          <div className="curency-image">
                            <img
                              src={"/images/main/currency1.png"}
                              alt="logo"
                              className="img-fluid"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12 col-md-12 col-12 col-sm-12">
                          <div className="people-currency py-3">
                            <h4 className="px-3">
                              Key Benefits Of
                              <span style={{ color: "#008c80" }}>
                                {" "}
                                Trading Forex
                              </span>
                            </h4>
                            <p className="mt-3">
                              <i className="altick">
                                <FaCheck />
                              </i>
                              Whether you start with a small investment or a larger sum, forex trading remains the preferred choice for traders worldwide:
                            </p>
                            <p>
                              <i className="altick">
                                <FaCheck />
                              </i>
                              High Liquidity translates to enhanced opportunities for growth.
                            </p>
                            <p>
                              <i className="altick">
                                <FaCheck />
                              </i>
                              24/5 Availability of the market allows you to copy trade at your convenience.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12 col-md-12 col-12 col-sm-12">
                          <div className="currency-assets px-3 py-3">
                            <h4>
                              Why Copy trade
                              <span style={{ color: "#008c80" }}>
                                {" "}
                                Forex with Millance LTD?
                              </span>
                            </h4>
                          </div>
                          <div className="currency-asset1">
                            <p>
                              <i className="altick">
                                <FaCheck />
                              </i>
                              Enjoy zero spread on popular FX pairs such as EUR/USD and USD/JPY with our top-tier accounts.
                            </p>
                            <p>
                              <i className="altick">
                                <FaCheck />
                              </i>
                              Execute trades at market prices with precision and speed, ensuring you get the best deal every time.
                            </p>
                            <p>
                              <i className="altick">
                                <FaCheck />
                              </i>
                              Secure Fund Management, with your funds held in segregated accounts at tier-1 banks.
                            </p>
                          </div>
                          <div className="mt-3 py-3 px-3">
                            <h4>
                              How Forex Trading
                              <span style={{ color: "#008c80" }}>
                                {" "}
                                Works at Millance LTD?
                              </span>
                            </h4>
                            <p className="mt-3">
                              Millance LTD provides access to forex trading through CFD products. When trading currency pairs, you are either buying or selling the base currency against the quote currency. This system allows you to copy trade currencies based on their relative value in the global market.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="v-pills-link2"
                      role="tabpanel"
                      aria-labelledby="v-pills-link2-tab"
                    >
                      <div className="row">
                        <div className="col-lg-6 col-md-12 col-12 col-sm-12 d-flex align-items-center">
                          <div className="commodities px-3">
                            <h4>
                              Find Opportunity Biggest
                              <span style={{ color: "#008c80" }}>
                                Commodities Markets
                              </span>
                            </h4>
                            <p className="mt-3">
                              Online commodity CFD trading is available with
                              variable leverage and affordable spreads—Trade
                              the world commodity market with Millance LTD for
                              everything from gold and silver to oil.
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12 col-12 col-sm-12">
                          <div className="commodities-image">
                            <img
                              src={"/images/main/commodities1.png"}
                              alt="logo"
                              className="img-fluid"
                            />
                          </div>
                        </div>
                        <div className="commodity-trade mt-2">
                          <h4 className="px-3">
                            Key Benefits Of Trading
                            <span style={{ color: "#008c80" }}>
                              {" "}
                              Commodities?
                            </span>
                          </h4>
                          <p className="">
                            <i className="altick">
                              <FaCheck />
                            </i>
                            Frequently regarded as potential safe havens.
                          </p>
                          <p className="">
                            <i className="altick">
                              <FaCheck />
                            </i>
                            Beneficial for portfolio diversification.
                          </p>
                          <p className="">
                            <i className="altick">
                              <FaCheck />
                            </i>
                            When there is uncertainty, this is common.
                          </p>
                        </div>
                        <div className="commodity-trade1 mt-3">
                          <h4 className="px-3">
                            Why Trade Commodities
                            <span style={{ color: "#008c80" }}>
                              With millance?
                            </span>
                          </h4>
                          <p className="px-3 mt-3">
                            Trade commodities instruments like gold, silver,
                            and copper with confidence and dependability. We
                            provide our customers with a straightforward and
                            user-friendly trading platform for all of our
                            commodities, packed with cutting-edge technologies
                            to facilitate wiser trading choices.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="v-pills-link3"
                      role="tabpanel"
                      aria-labelledby="v-pills-link3-tab"
                    >
                      <div className="row">
                        <div className="col-lg-6 col-md-12 col-12 col-sm-12">
                          <div className="indices1">
                            <h4 className="px-3">
                              Find Opportunity In
                              <span style={{ color: "#008c80" }}>
                                {" "}
                                Indices Markets.{" "}
                              </span>
                            </h4>
                            <p>
                              <i className="altick">
                                <FaCheck />
                              </i>
                              Copy trade 30+ indices as CFDs through a
                              reputable, broker with no
                              commission and extremely low spreads.
                            </p>
                          </div>
                          <div className="indices1">
                            <h4 className="px-3">
                              Key Benefits of
                              <span style={{ color: "#008c80" }}>
                                Trading Indices
                              </span>
                            </h4>
                            <p>
                              <i className="altick">
                                <FaCheck />
                              </i>
                              Instead of relying solely on the strength of one
                              pair, spread your risk.
                            </p>
                            <p>
                              <i className="altick">
                                <FaCheck />
                              </i>
                              Copy trade at any time, day or night, seven days a
                              week, because the currency market is open 24
                              hours a day.
                            </p>
                            <p>
                              <i className="altick">
                                <FaCheck />
                              </i>
                              Available across all trading platforms and
                              accounts.
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12 col-12 col-sm-12">
                          <div className="indices image">
                            <img
                              src={"/images/main/indices3.png"}
                              alt="logo"
                              className="img-fluid"
                            />
                          </div>
                        </div>
                        <div className="col-lg-12 col-md-12 col-12 col-sm-12">
                          <div className="indices-work">
                            <h4 className="px-3">
                              Why Copy trade Indices
                              <span style={{ color: "#008c80" }}>
                                With Millance LTD?
                              </span>
                            </h4>
                            <p>
                              <i className="altick">
                                <FaCheck />
                              </i>
                              Copy trade a currency group&apos;s trend instead of
                              opening numerous positions on different currency
                              pairs.
                            </p>
                            <p>
                              <i className="altick">
                                <FaCheck />
                              </i>
                              You may always get assistance with your trading
                              account on Monday through Friday.
                            </p>
                            <p>
                              <i className="altick">
                                <FaCheck />
                              </i>
                              Utilize the account with the lowest trading
                              fees, Advantage, to access FX indices on both
                              MT5.
                            </p>
                            <p>
                              <i className="altick">
                                <FaCheck />
                              </i>
                              Open a trading account and begin trading FX
                              indices in just a few minutes.
                            </p>
                          </div>
                          <div className="indices-work1">
                            <h4 className="px-3">
                              How Does Indices
                              <span style={{ color: "#008c80" }}>
                                Trading Work?
                              </span>
                            </h4>
                            <p className="indi1 d-flex">
                              <i className="altick">
                                <FaCheck />
                              </i>
                              An FX index, made up of 5 or 6 main pairings,
                              gauges the strength of one currency relative to
                              a group of other essential FX pairs.
                            </p>
                            <p>
                              <i className="altick">
                                <FaCheck />
                              </i>
                              The price changes of these currency pairs
                              directly affect the index&apos;s strength.
                            </p>
                            <p>
                              <i className="altick">
                                <FaCheck />
                              </i>
                              The index&apos;s value rises when the price of that
                              currency relative to other currencies does.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="v-pills-link4"
                      role="tabpanel"
                      aria-labelledby="v-pills-link4-tab"
                    >
                      <div className="row">
                        <div className="col-lg-6 col-md-12 col-12 col-sm-12">
                          <div className="shares-page">
                            <h4 className="px-3">
                              Find Opportunity In
                              <span style={{ color: "#008c80" }}>
                                Share Markets.
                              </span>
                            </h4>
                            <p className="px-3">
                              Leverage allows you to have exposure to various
                              shares in Australia, the US, the UK, and
                              Germany. Cheap commissions, high liquidity, and
                              razor-sharp pricing.
                            </p>
                          </div>
                          <div className="shares-page1">
                            <h4 className="px-3">
                              Key Benefits Of
                              <span style={{ color: "#008c80" }}>
                                Trading Shares
                              </span>
                            </h4>
                            <p className="">
                              <i className="altick">
                                <FaCheck />
                              </i>
                              Own a stake in your preferred business, such as
                              Tesla or Apple.
                            </p>
                            <p className="">
                              <i className="altick">
                                <FaCheck />
                              </i>
                              An excellent option for long-term investing.
                            </p>
                            <p className="">
                              <i className="altick">
                                <FaCheck />
                              </i>
                              Less dangerous than CFDs because leverage is not
                              used in trading.
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12 col-12 col-sm-12">
                          <div className="share-image text-center">
                            <img
                              src={"/images/main/share3.png"}
                              alt="logo"
                              className="img-fluid"
                            />
                          </div>
                        </div>

                        <div className="shares-page2">
                          <h4 className="px-3">
                            Why Copy trade Indices
                            <span style={{ color: "#008c80" }}>
                              {" "}
                              With Shares
                            </span>
                          </h4>
                          <p className="px-3">
                            Looking for a way to make money on some of the
                            most well-liked stocks without paying
                            commissions? With Millance LTD, start learning about
                            trading CFDs on shares.
                          </p>
                        </div>
                        <div className="shares-page3">
                          <h4 className="px-3">
                            How Does Share
                            <span style={{ color: "#008c80" }}>
                              Trading Work?
                            </span>
                          </h4>
                          <p className="px-3">
                            The buying and selling of stock refer to the
                            ownership of a firm. To turn a profit is the aim.
                            A little portion of a corporation becomes yours
                            after you purchase shares in it. The ups and downs
                            in the company&apos;s stock price will affect how much
                            your part is worth. You cannot open sell (short)
                            positions on stocks using our stock trading
                            service, but you are still permitted to sell any
                            shares you currently own in order to potentially
                            make a profit.
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      className="tab-pane fade"
                      id="v-pills-link5"
                      role="tabpanel"
                      aria-labelledby="v-pills-link5-tab"
                    >
                      <div>
                        <h4 className="px-3">
                          Fast, Simple, and reasonably priced. Start your
                          cryptocurrency journey!
                        </h4>
                      </div>
                      <div className="row">
                        <div className="col-lg-6 col-md-12 col-12 col-sm-12">
                          <div className="cryptocurrencies mt-3">
                            <h4 className="px-3">
                              Find Opportunity In
                              <span style={{ color: "#008c80" }}>
                                Crypto Markets.
                              </span>
                            </h4>
                            <p className="px-3">
                              Digital currencies known as cryptocurrency CFDs
                              are subject to significant price fluctuations.
                              By trading bitcoin CFDs with Millance LTD without
                              using a digital wallet or a cryptocurrency
                              exchange, you can profit from this volatility.
                            </p>
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-12 col-12 col-sm-12">
                          <div className="crypto-image">
                            <img
                              src={"/images/main/cryptocurrency1.png"}
                              alt="logo"
                              className="img-fluid"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-12 col-md-12 col-12 col-sm-12">
                          <div className="currency-service">
                            <h4 className="px-3">
                              Key Benefits Of
                              <span style={{ color: "#008c80" }}>
                                Trading Crypto
                              </span>
                            </h4>
                            <p>
                              <i className="altick">
                                <FaCheck />
                              </i>
                              With Millance LTD, you may copy trade cryptocurrencies
                              without having to pay a commission on any
                              transactions.
                            </p>
                            <p>
                              <i className="altick">
                                <FaCheck />
                              </i>
                              Copy trade cryptocurrencies using the same MT5
                              trading platform to avoid the hassles of a
                              digital wallet.
                            </p>
                            <p>
                              <i className="altick">
                                <FaCheck />
                              </i>
                              YazhiFX does not charge any fees for withdrawals
                              and deposits. We are here to help you 24/5.
                            </p>
                            <p>
                              <i className="altick">
                                <FaCheck />
                              </i>
                              With 0% commission and our low spreads, trading
                              cryptocurrency is more economical.
                            </p>
                          </div>
                          <div className="mt-2">
                            <h4 className="px-3">
                              Why Copy trade Indices
                              <span style={{ color: "#008c80" }}>
                                {" "}
                                With Crypto?
                              </span>
                            </h4>
                            <p className="px-3">
                              Learn about the advantages of trading
                              cryptocurrency CFDs and get a taste of the world
                              of virtual money like Bitcoin, Ethereum, and
                              Litecoin.
                            </p>
                          </div>
                          <div className="mt-3">
                            <h4 className="px-3">
                              How Does Crypto
                              <span style={{ color: "#008c80" }}>
                                Trading Work?
                              </span>
                            </h4>
                            <p className="px-3">
                              There are two simple approaches to
                              cryptocurrency investing. The first involves
                              purchasing cryptocurrencies via a digital wallet
                              at the going market rate, which is like to stock
                              investment. When you sell the currency for more
                              than you purchased it, you make money.
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="col-lg-2 col-md-12 col-12 col-sm-12">
                  <div className="asset-content1 mt-4 pt-3">
                    <div className="assets-content2">
                      <h4>Assets</h4>
                    </div>
                    <div
                      className="nav flex-column nav-pills mt-4"
                      id="v-pills-tab"
                      role="tablist"
                      aria-orientation="vertical"
                    >
                      <Link
                        to="/forex-currency-trading"
                        className="nav-link active mt-2"
                        // id="v-pills-link1-tab"
                        // data-bs-toggle="pill"
                        // href="#v-pills-link1"
                        role="tab"
                        aria-controls="v-pills-link1"
                        aria-selected="true"
                      >
                        Currency
                      </Link>
                      <Link
                        to="/commodities"
                        className="nav-link"
                        // id="v-pills-link2-tab"
                        // data-bs-toggle="pill"
                        // href="#v-pills-link2"
                        // role="tab"
                        aria-controls="v-pills-link2"
                        aria-selected="false"
                      >
                        Commodities
                      </Link>
                      <Link
                        to="/indices-trading"
                        className="nav-link"
                        // id="v-pills-link3-tab"
                        // data-bs-toggle="pill"
                        // href="#v-pills-link3"
                        // role="tab"
                        aria-controls="v-pills-link3"
                        aria-selected="false"
                      >
                        Indices
                      </Link>
                      
                  
                    </div>
                  </div>
                  <div className="asset-content-box1 mt-4 pt-3">
                    <div className="assets-content3">
                      <h4>Analytics</h4>
                    </div>
                    <div
                      className="nav flex-column nav-pills mt-4"
                      id="v-pills-tab"
                      role="tablist"
                      aria-orientation="vertical"
                    >
                      <Link
                        to="/forex-market-analysis"
                        className="nav-link active mt-2"
                        // id="v-pills-link6-tab"
                        // data-bs-toggle="pill"
                        // href="#v-pills-link6"
                        // role="tab"
                        aria-controls="v-pills-link6"
                        aria-selected="true"
                      >
                        Market Analytical
                      </Link>
                      <Link
                        to="/economic-calendar"
                        className="nav-link"
                        // id="v-pills-link7-tab"
                        // data-bs-toggle="pill"
                        // href="#v-pills-link7"
                        // role="tab"
                        aria-controls="v-pills-link7"
                        aria-selected="false"
                      >
                        Economic Calendar
                      </Link>
                      <Link
                        to="/pip-calculator"
                        className="nav-link"
                        // id="v-pills-link8-tab"
                        // data-bs-toggle="pill"
                        // href="#v-pills-link8"
                        // role="tab"
                        aria-controls="v-pills-link8"
                        aria-selected="false"
                      >
                        Trader Calculators
                      </Link>
                    </div>
                  </div>
                </div> */}
            </div>
            <div className="assets-icons-page">
              <div className="container">
                <div className="tab-content" id="v-pills-tabContent">
                  <div
                    className="tab-pane fade show active"
                    id="v-pills-link1"
                    role="tabpanel"
                    aria-labelledby="v-pills-link1-tab"
                  >
                    <div className="row">
                      <div className="col-lg-3 col-md-12 col-12 col-sm-12">
                        <div className="card testimonial-card mt-2 mb-3">
                          {" "}
                          <div ref={currencygraph1}></div>{" "}
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-12 col-12 col-sm-12">
                        <div className="card testimonial-card mt-2 mb-3">
                          <div ref={currencygraph2}></div>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-12 col-12 col-sm-12">
                        <div className="card testimonial-card mt-2 mb-3">
                          <div ref={currencygraph3}></div>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-12 col-12 col-sm-12">
                        <div className="card testimonial-card mt-2 mb-3">
                          <div ref={currencygraph4}></div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="v-pills-link2"
                    role="tabpanel"
                    aria-labelledby="v-pills-link2-tab"
                  >
                    <div className="row">
                      <div className="col-lg-3 col-md-12 col-12 col-sm-12">
                        <div className="card testimonial-card mt-2 mb-3">
                          <div className="card-up aqua-gradient" />
                          <div className="avatar mx-auto white">
                            <img
                              src={"/images/main/tesla.png"}
                              alt="logo"
                              className="img-fluid"
                            />
                          </div>
                          <h2>jcbkcnz</h2>
                          <div className="card-body text-center">
                            <h3>GBP/USD</h3>
                            <strong>
                              1.20712
                              <small className="text-success px-2">
                                +0.87%
                              </small>
                            </strong>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-12 col-12 col-sm-12">
                        <div className="card testimonial-card mt-2 mb-3">
                          <div className="card-up aqua-gradient" />
                          <div className="avatar mx-auto white">
                            <img
                              src={"/images/main/icon2.png"}
                              alt="logo"
                              className="img-fluid"
                            />
                          </div>
                          <div className="card-body text-center">
                            <h3>EUR/USD</h3>
                            <strong>
                              1.06189
                              <small className="text-danger px-2">
                                -0.69%
                              </small>
                            </strong>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-12 col-12 col-sm-12">
                        <div className="card testimonial-card mt-2 mb-3">
                          <div className="card-up aqua-gradient" />
                          <div className="avatar mx-auto white">
                            <img
                              src={"/images/main/icon4.png"}
                              alt="logo"
                              className="img-fluid"
                            />
                          </div>
                          <div className="card-body text-center">
                            <h3>USD/JPY</h3>
                            <strong>
                              130.385
                              <small className="text-danger px-2">
                                -0.46%
                              </small>
                            </strong>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-12 col-12 col-sm-12">
                        <div className="card testimonial-card mt-2 mb-3">
                          <div className="card-up aqua-gradient" />
                          <div className="avatar mx-auto white">
                            <img
                              src={"/images/main/icon5.png"}
                              alt="logo"
                              className="img-fluid"
                            />
                          </div>
                          <div className="card-body text-center">
                            <h3>USD/CHF</h3>
                            <strong>
                              0.92643
                              <small className="text-danger px-2">
                                -1.02%
                              </small>
                            </strong>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section className="trade getmt5 mt-4 pb-5">
          <div className="getsmt5">
            <div className="container">
              <h2 className="text-center">Get Started</h2>
              <p className="getapara">
                Start trading anytime, anywhere with ease. Our platform is built for efficiency, security, and ease of use.
              </p>
              <div className="row mt-5 align-items-center">
                <div className="col-md-12 col-lg-9">
                  <div className="row">
                    <div className="col-md-12 col-lg-3">
                      <div className="box1get">
                        <img
                          src={"/images//algoimg/singupicon1.png"}
                          alt="logo"
                          className="img-fluid mb-3"
                        />
                        <h4 className="my-1 mb-3">Register</h4>
                        <p className="mb-0 font-13">
                          Sign up and create your trading account in minutes.
                        </p>
                      </div>
                    </div>
                    <div className="col-md-12 col-lg-3">
                      <div className="box1get">
                        <img
                          src={"/images/algoimg/verifyicon1.png"}
                          alt="logo"
                          className="img-fluid mb-3"
                        />
                        <h4 className="my-1 mb-3">Verify</h4>
                        <p className="mb-0 font-13">
                          Upload the required documents for instant verification.
                        </p>
                      </div>
                    </div>
                    <div className="col-md-12 col-lg-3">
                      <div className="box1get">
                        <img
                          src={"/images/algoimg/depositicon1.png"}
                          alt="logo"
                          className="img-fluid mb-3"
                        />
                        <h4 className="my-1 mb-3">Deposit</h4>
                        <p className="mb-0 font-13">
                          Fund your account with a minimum of $100.
                        </p>
                      </div>
                    </div>
                    <div className="col-md-12 col-lg-3">
                      <div className="box1get">
                        <img
                          src={"/images/algoimg/tradeicon1.png"}
                          alt="logo"
                          className="img-fluid mb-3"
                        />
                        <h4 className="my-1 mb-3">Copy trade</h4>
                        <p className="mb-0 font-13">
                          Start trading across a range of instruments and maximize your potential!
                        </p>
                      </div>
                    </div>
                    <div className="d-flex justify-content-center getsbtn mt-5">
                      <div className="openlivebtn">
                        <Link href={'https://crm.millance.com/register'} target="_blank">
                          <button type="button" className="btn btn-primary">
                            Open Live Account
                          </button>
                        </Link>
                      </div>
                      {/* <div className="opendemobtn">
                          <a href="https://crm.millance.com/opendemoaccount">
                            <button type="button" className="btn btn-primary">
                              Open Demo Account
                            </button>
                          </a>
                        </div> */}
                    </div>
                  </div>
                </div>
                <div className="col-md-12 col-lg-3">
                  <div className="getimg">
                    <img
                      src={"/images/home/getstartimg1.gif"}
                      alt="logo"
                      className="img-fluid"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default Currency;
